import { CspSessionType } from 'src/app/CspSignin/redux/cspSignin.reducer'

export const SET_SELECTED_CSP_SESSION_TYPE =
  'app/cspSignin/SET_SELECTED_CSP_SESSION_TYPE'

export interface SetSelectedCspSessionTypeAction {
  type: typeof SET_SELECTED_CSP_SESSION_TYPE
  payload: {
    sessionType: CspSessionType | undefined
  }
}

export const createSetSelectedCspSessionTypeAction = (
  sessionType: CspSessionType | undefined,
): SetSelectedCspSessionTypeAction => ({
  type: SET_SELECTED_CSP_SESSION_TYPE,
  payload: {
    sessionType,
  },
})

export const RESET_CSP_SIGNIN_STATE = 'app/cspSignin/RESET_CSP_SIGNIN_STATE'
export interface ResetCspSigninStateAction {
  type: typeof RESET_CSP_SIGNIN_STATE
}
export const createResetCspSigninState = (): ResetCspSigninStateAction => ({
  type: RESET_CSP_SIGNIN_STATE,
})
